import type { CSSObject } from "type/tss";

export const styles = () => {
	return ({
		root: {
			display: "block",
			border: "none",
			fontSize: "1rem",
		},
		spacer: {
			display: "none",
		},
		actions: {
			marginLeft: "auto",
		},
	} satisfies Record<string, CSSObject>);
};
